import * as React from 'react'

const SvgSortAmountIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4247_88329)">
      <path
        d="M20.0002 6.66667C20.0002 7.12751 19.6277 7.50001 19.1668 7.50001H8.33349C7.87349 7.50001 7.50016 7.12751 7.50016 6.66667C7.50016 6.20584 7.87349 5.83334 8.33349 5.83334H19.1668C19.6277 5.83334 20.0002 6.20584 20.0002 6.66667ZM16.6668 10H8.33349C7.87349 10 7.50016 10.3725 7.50016 10.8333C7.50016 11.2942 7.87349 11.6667 8.33349 11.6667H16.6668C17.1277 11.6667 17.5002 11.2942 17.5002 10.8333C17.5002 10.3725 17.1277 10 16.6668 10ZM14.1668 14.1667H8.33349C7.87349 14.1667 7.50016 14.5392 7.50016 15C7.50016 15.4608 7.87349 15.8333 8.33349 15.8333H14.1668C14.6277 15.8333 15.0002 15.4608 15.0002 15C15.0002 14.5392 14.6277 14.1667 14.1668 14.1667ZM11.6668 18.3333H8.33349C7.87349 18.3333 7.50016 18.7058 7.50016 19.1667C7.50016 19.6275 7.87349 20 8.33349 20H11.6668C12.1277 20 12.5002 19.6275 12.5002 19.1667C12.5002 18.7058 12.1277 18.3333 11.6668 18.3333ZM7.60182 2.74417L5.34516 0.48834C4.69599 -0.160827 3.63766 -0.160827 2.98849 0.48834L0.732656 2.74417C0.406823 3.07001 0.406823 3.59667 0.732656 3.92251C1.05849 4.24834 1.58516 4.24834 1.91099 3.92251L3.33349 2.50001V19.1667C3.33349 19.6275 3.70682 20 4.16682 20C4.62682 20 5.00016 19.6275 5.00016 19.1667V2.50001L6.42349 3.92251C6.58599 4.08501 6.79932 4.16667 7.01266 4.16667C7.22599 4.16667 7.43932 4.08501 7.60182 3.92251C7.92766 3.59667 7.92766 3.07001 7.60182 2.74417Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4247_88329">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSortAmountIcon
